import React, { FC, forwardRef, MouseEvent, Ref } from 'react';
import './action-ellipsis.scss';

interface IProps {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  forwardedRef: Ref<HTMLButtonElement>;
  customClasses?: string;
  isDisabled?: boolean;
}

const DefaultThreeDots = () => {
  return <div className='three-dots'/>;
};

const ActionEllipsis: FC<IProps> = forwardRef(({ isDisabled, children, customClasses, forwardedRef, ...props }): JSX.Element => (
  <button disabled={isDisabled} ref={forwardedRef} className={`action-ellipsis ${customClasses || ''}`} {...props}>
    {children || <DefaultThreeDots/>}
  </button>
));

export default ActionEllipsis;